module.exports = __webpack_public_path__ + "img/default-image.bb5a424c.svg";